module.exports = __webpack_public_path__ + "img/message.20d8cd6a.svg";